module.exports = __webpack_public_path__ + "static/img/b5.0276b79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/b5.png
// module id = KIyP
// module chunks = 1